/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { CreditLedgerExportRequestCategoriesItem } from './creditLedgerExportRequestCategoriesItem';
import type { CreditLedgerExportRequestDirection } from './creditLedgerExportRequestDirection';
import type { CreditLedgerExportRequestExcludeCategoriesItem } from './creditLedgerExportRequestExcludeCategoriesItem';

/**
 * Filters for the CSV export — the same set the ledger list accepts,
 * so an export always matches what the table is showing.
 */
export interface CreditLedgerExportRequest {
  categories?: CreditLedgerExportRequestCategoriesItem[];
  /** @maxItems 32 */
  entry_types?: string[];
  /** @maxItems 100 */
  actor_user_ids?: string[];
  exclude_categories?: CreditLedgerExportRequestExcludeCategoriesItem[];
  /** @maxItems 32 */
  exclude_entry_types?: string[];
  /** @maxItems 100 */
  exclude_actor_user_ids?: string[];
  occurred_from?: string | null;
  occurred_to?: string | null;
  direction?: CreditLedgerExportRequestDirection;
  /** @maxLength 64 */
  tz?: string;
  range_days?: number | null;
}
